document.querySelectorAll('.gallery-section').forEach(section => {
    const inner = section.querySelector('.gallery-section-inner');
    const gallery = inner.querySelector('.gallery-section-entries');
    const entries = gallery.querySelectorAll('.gallery-section-entry');

    // add an enlarge button to each slide
    entries.forEach(entry => {
        const enlargeButton = document.createElement('button');
        enlargeButton.classList.add('gallery-section-enlarge');
        enlargeButton.innerHTML = '<i class="fas fa-arrow-up-right-and-arrow-down-left-from-center"></i>';
        entry.appendChild(enlargeButton);
    });
});